export default (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.6477 8.75475L8.15242 9.24194C6.46668 8.38966 5.42566 7.4104 4.81971 5.88411L5.28629 3.36269L4.40464 1H2.13173C1.44822 1 0.91014 1.569 1.01255 2.24972C1.26704 3.94878 2.01842 7.03005 4.21376 9.24194C6.51939 11.5649 9.84059 12.5729 11.6681 12.974C12.3741 13.1285 13 12.5741 13 11.8458V9.6577L10.6477 8.75475Z"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
